import getValueFromQueryParams from "../utils/parse-query-params";
import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'showroom-event';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    loader: ".js-loader",
    title: ".js-showroom-event-title",
    date: ".js-showroom-event-date",
    time: ".js-showroom-event-time",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalClose: ".js-modal-close",
    modalEdit: ".js-modal-edit",
    modalEditTrigger: ".js-edit-modal-trigger",
    editForm: ".js-edit-form",
    inputID: ".js-input-id",
    datePickerValue: ".js-date-picker-value",
    d: ".js-d",
    h: ".js-h",
    m: ".js-m",
    s: ".js-s",
    visible: "visible"
  }

  class ShowroomEvent extends HTMLElement {
    constructor() {
      super();

      this.data = {};

      this.html = document.querySelector(selectors.html);
      this.modalClose = this.querySelectorAll(selectors.modalClose);
      this.modalEdit = this.querySelector(selectors.modalEdit);
      this.modalEditTrigger = this.querySelector(selectors.modalEditTrigger);
      this.editForm = this.querySelector(selectors.editForm);
      this.inputID = this.querySelector(selectors.inputID);
      this.loader = this.querySelector(selectors.loader);

      this.init();
    }

    timeCountdown(time) {
      const timeEl = this.querySelector(selectors.time);
      const d = timeEl.querySelector(selectors.d);
      const h = timeEl.querySelector(selectors.h);
      const m = timeEl.querySelector(selectors.m);
      const s = timeEl.querySelector(selectors.s);

      const timeUnits = [
        { key: d, value: 1000 * 60 * 60 * 24 },
        { key: h, value: 1000 * 60 * 60 },
        { key: m, value: 1000 * 60 },
        { key: s, value: 1000 }
      ];

      const interval = setInterval(() => {
        const now = new Date();
        let difference = time - now;

        if (difference > 0) {
          timeUnits.forEach(unit => {
            unit.key.textContent = Math.floor(difference / unit.value);
            difference %= unit.value;
          });
        } else {
          clearInterval(interval);
        }
      }, 1000);
    }

    setData() {
      const title = this.querySelector(selectors.title);
      const date = this.querySelector(selectors.date);
      const dateObj = new Date(this.data.weddingDate);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };

      title.textContent = `${this.data.title}'s`;
      date.textContent = dateObj.toLocaleDateString('en-US', options);

      this.timeCountdown(dateObj);
    }

    async handleEditFormSubmit(e) {
      e.preventDefault();

      const formData = new FormData(this.editForm);
      const id = formData.get("id");

      const body = {
        title: formData.get("name"),
        weddingDate: this.editForm.querySelector(selectors.datePickerValue).value
      }

      await fetchShowroomApi(`/showrooms/${id}`, "PUT", JSON.stringify(body));

      window.location.reload();
    }

    openModal(modal) {
      this.html.classList.add("overflow-hidden");
      modal.classList.add("opened");
    }

    closeModal(modal) {
      this.html.classList.remove("overflow-hidden");
      modal.classList.remove("opened");
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    initModal() {
      this.modalEditTrigger && this.modalEditTrigger.addEventListener("click",() => {
        this.openModal(this.modalEdit);
        this.modalEdit.querySelector("input[name='name']").value = this.data.title;
      });
      this.modalEdit.addEventListener("click", e => this.handleModalCloseOutside(e, this.modalEdit));
      this.modalClose.forEach(el => el.addEventListener("click", () => this.closeModal(this.modalEdit)));

      this.editForm.addEventListener("submit", e => this.handleEditFormSubmit(e))
    }

    checkIsOwner() {
      if (!this.data.currentCustomerIsOwner) {
        this.modalEditTrigger.classList.add("hidden");
      }
    }

    async init() {
      const showroomId = getValueFromQueryParams("id") || window.localStorage.getItem("last_viewed_showroom");
      const inviteToken = window.localStorage.getItem("invite_token");

      if (inviteToken) {
        await fetchShowroomApi(`/showrooms/invite/accept`, "POST", JSON.stringify({
          "inviteToken": inviteToken
        }));

        window.localStorage.removeItem("invite_token");
        window.localStorage.removeItem("inviteToShowroomId");
        window.location.reload();
      }

      if (showroomId) {
        this.data = await fetchShowroomApi(`/showrooms/${showroomId}`);

        const url = new URL(window.location);

        if (!this.data) {
          url.searchParams.set("id", "");
          window.history.pushState({}, '', url);

          window.location.pathname = "/pages/showroom";
        }

        url.searchParams.set("id", this.data.id);
        window.history.pushState({}, '', url);

        window.localStorage.setItem("last_viewed_showroom", showroomId);

        this.inputID.value = showroomId;

        this.checkIsOwner();
      } else {
        const quizPayload = JSON.parse(window.localStorage.getItem("quizPayload"));

        const createPayload = {
          ...quizPayload,
          "ownerName": window.customerFirstName,
          "ownerEmail": window.customerEmail,
        }

        if (quizPayload) {
          this.data = await fetchShowroomApi(`/showrooms`, "POST", JSON.stringify(createPayload));

          if (this.data) {
            this.checkIsOwner();

            const url = new URL(window.location);

            url.searchParams.set("id", this.data.id);
            window.history.pushState({}, '', url);

            window.localStorage.removeItem("quizPayload");
            window.localStorage.setItem("last_viewed_showroom", this.data.id);

            this.inputID.value = this.data.id;
          }
        } else {
          if (!window.is_customize) {
            window.location.pathname = "/pages/showroom"
          }
        }
      }

      this.setData();
      this.initModal();

      this.loader.classList.remove(selectors.visible);
    }
  }

  customElements.define(customElements.component, ShowroomEvent);
}
